import normalize from 'jsonapi-normalizer'
import {
  fork,
  call,
  put,
  takeEvery,
} from 'redux-saga/effects'

import {
  removeEntities,
  removeResults,
  removeEntityRow,
  removeResultRow,
  updateEntities,
  updateResults,
  overwriteEntities,
  overwriteResults
} from './actions'

import {
  UPDATE_TABLES,
  REMOVE_TABLES,
  REMOVE_ROW,
  OVERWRITE_TABLES
} from './constants'

function* updateTables(action) {
  const { data } = action
  const { entities, result } = data
  yield put(updateEntities(entities))
  yield put(updateResults(result))
  return data
}

function* removeTables(action) {
  const { tableName } = action
  yield put(removeEntities(tableName))
  yield put(removeResults(tableName))
  return tableName
}

function* removeRow(action) {
  const { tableName, id } = action
  yield put(removeResultRow(tableName, id))
  yield put(removeEntityRow(tableName, id))
}

function* overwriteTables(action){
  const { data } = action
  const { entities, result } = data
  yield put(overwriteEntities(entities))
  yield put(overwriteResults(result))
  //return data
}

function* watchUpdateTables() {
  yield takeEvery(UPDATE_TABLES, updateTables)
}

function* watchRemoveTables() {
  yield takeEvery(REMOVE_TABLES, removeTables)
}

function* watchRemoveRow() {
  yield takeEvery(REMOVE_ROW, removeRow)
}

function* watchOverwriteTables(){
  yield takeEvery(OVERWRITE_TABLES, overwriteTables)
}

export {
  updateTables,
  watchRemoveTables,
  watchUpdateTables,
  watchRemoveRow,
  watchOverwriteTables
}
